import React from "react";
import {
  GiMeditation,
  GiLotus,
  GiHealing,
  GiHeartOrgan,
} from "react-icons/gi";
import { FaSmile, FaLeaf, FaSmokingBan } from "react-icons/fa";
import { MdOutlineSelfImprovement } from "react-icons/md";

const benefits = [
  {
    icon: <GiMeditation size={32} />,
    title: "Deep Meditation",
    desc: "Experience thoughtless awareness and inner silence.",
  },
  {
    icon: <GiLotus size={32} />,
    title: "Chakra Cleansing",
    desc: "Balance and cleanse your energy centers naturally.",
  },
  {
    icon: <FaSmile size={32} />,
    title: "Mental Peace",
    desc: "Reduce stress, anxiety, and emotional turbulence.",
  },
  {
    icon: <GiHealing size={32} />,
    title: "Holistic Healing",
    desc: "Support physical, mental, and emotional well-being.",
  },
  {
    icon: <FaLeaf size={32} />,
    title: "Natural & Effortless",
    desc: "No rituals, no cost—just pure inner connection.",
  },
  {
    icon: <FaSmokingBan size={32} />,
    title: "Overcome Bad Habits",
    desc: "Transform addictive behaviors through self-realization.",
  },
  {
    icon: <MdOutlineSelfImprovement size={32} />,
    title: "Self-Improvement",
    desc: "Grow spiritually and become your best version.",
  },
  {
    icon: <GiHeartOrgan size={32} />,
    title: "Heart Opening",
    desc: "Feel more compassion, joy, and love.",
  },
];

const Benefits = () => {
  return (
    <section className="bg-white py-16 px-4 sm:px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-green-700 mb-10">
          Benefits of Sahaja Yoga
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-green-50 p-5 sm:p-6 rounded-2xl shadow hover:shadow-lg transition duration-300 text-center"
            >
              <div className="text-green-600 mb-4 flex justify-center">
                {benefit.icon}
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-800">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-600">{benefit.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
